import ErrorFallback from "@app/components/ErrorFallback/ErrorFallback";
import { useRouteError } from "react-router";

export default function ErrorRoute() {
  const error = useRouteError();
  return <ErrorFallback error={error} resetErrorBoundary={() => window.location.reload()} />;
}
